import { LineClampOptions } from '@arpeggi/ui'
import { FC, useMemo } from 'react'
import { useComments } from '../discussions-queries/queries/useComments'
import { InfiniteScroll } from '../infinite-scroll'
import { CreateComment } from './components'
import { CommentCard } from './components/CommentCard'
import { Comments, Root } from './primitives'

interface Props {
  discussionId: number
  perPage?: number
  disableInfintieScroll?: boolean
  commentLineClamp?: LineClampOptions
}

export const Discussion: FC<Props> = ({
  discussionId,
  perPage = 25,
  disableInfintieScroll,
  commentLineClamp
}) => {
  const commentsQuery = useComments({ discussionId, params: { perPage, order: 'desc' } })
  const flattenedComments = useMemo(
    () => commentsQuery.data?.pages.flatMap((page) => page.data.map((comment) => comment)) || [],
    [commentsQuery.data]
  )

  return (
    <Root>
      <CreateComment discussionId={discussionId} />
      {commentsQuery.isLoading && <InfiniteScroll.Spinner />}
      {!commentsQuery.isLoading && (
        <Comments.InfiniteScroll
          dataLength={commentsQuery.data?.pages.length * perPage}
          next={commentsQuery.fetchNextPage}
          hasMore={disableInfintieScroll ? false : commentsQuery.hasNextPage}
        >
          {flattenedComments.map((comment) => (
            <CommentCard key={comment.id} comment={comment} lineClamp={commentLineClamp} />
          ))}
        </Comments.InfiniteScroll>
      )}
    </Root>
  )
}
